module.exports = __webpack_public_path__ + "img/docks_tech_Normal_ua.8deb4a61.webp";